import { MetricUnit } from '@/__generated__/graphql';
import { useFormatters } from '@/hooks/useFormatters';
import { BatteryLevelIcon } from '@components/BatteryLevelIcon';
import TruncatedTypography from '@components/TruncatedTypography';
import { Trans } from '@lingui/macro';
import { Box } from '@mui/material';
import { FC } from 'react';
import { PanelPaper } from './common';

interface Props {
  movementId: string | null;
}

const CONNECTION_COLOR_MAP = {
  connected: '#0AEB0E',
  disconnected: 'grey',
};

export const PanelStatus: FC<Props> = ({ movementId }) => {
  const { formatMetricValue } = useFormatters();
  const connected = true;
  const batteryLevel = 50;

  const connectionColor = CONNECTION_COLOR_MAP[connected ? 'connected' : 'disconnected'];

  return (
    <PanelPaper
      sx={{
        gridArea: 'status',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        px: 4,
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Box height={14} width={14} borderRadius={32} bgcolor={connectionColor} />
        <TruncatedTypography fontWeight="medium" lineHeight={1} pb="1px">
          {connected ? <Trans>conectado</Trans> : <Trans>desconectado</Trans>}
        </TruncatedTypography>
      </Box>

      <Box display="flex" alignItems="center" gap="1px" pb="1px">
        <BatteryLevelIcon battery={batteryLevel} />
        <TruncatedTypography fontWeight="medium" lineHeight={1}>
          {formatMetricValue(batteryLevel, { unit: MetricUnit.Percent, precision: 0 })}
        </TruncatedTypography>
      </Box>
    </PanelPaper>
  );
};
